import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { BannerMessage } from '@model';
import { Store } from '@ngrx/store';
import * as fromInformationStore from '@core/store';
import * as fromConfigurationStore from "@appStore/configuration";
import { SubSink } from 'subsink';

@Component({
    selector: 'app-system-message-pane',
    templateUrl: './system-message-pane.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SystemMessagePaneComponent implements OnInit {

  @Input()
  isLoggedIn: boolean;
  
  messages: BannerMessage[] = [];
  preClosureMessage = { id: -1, isVisible: false, message: '', content: '', severity: 2, icon: '' } as BannerMessage;
  startPageBanner = { id: -2, isVisible: false, message: '', content: '', severity: 2, icon: '' } as BannerMessage;
  private subs = new SubSink();
  allMessagesDismissed = false;

  constructor(private informationStore: Store<fromInformationStore.InformationState>,
    private configurationStore: Store<fromConfigurationStore.State>,
    private changeDetectorRef: ChangeDetectorRef) { }


  ngOnInit() {

    
    this.subs.sink = this.informationStore.select(fromInformationStore.getBannerMessages).subscribe(banners => {
      //console.log(`system-message-pane\tgetBannerMessages`, banners);
      this.messages = banners;
      this.allMessagesDismissed = this.messages.every((message) => message.isVisible === false);
      this.changeDetectorRef.detectChanges();
    });

    this.subs.sink = this.informationStore.select(fromInformationStore.getPreClosureBanner).subscribe(preclosureMessage => {
      //console.log(`system-message-pane\tgetPreClosureBanner`, preclosureMessage);
      if (preclosureMessage){
        this.preClosureMessage = preclosureMessage;
        //console.log(`system-message-pane\tsetPreClosureMessage`);
        this.changeDetectorRef.detectChanges();
      }
    });

    this.subs.sink = this.informationStore.select(fromInformationStore.getStartPageBanner).subscribe(startPageBanner => {
      //console.log(`system-message-pane\tgetStartPageBanner`, startPageBanner);
      if (startPageBanner){
        this.startPageBanner = startPageBanner;
        //console.log(`system-message-pane\tsetStartPageBanner`);
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.changeDetectorRef.detach();
    this.subs.unsubscribe();
  }

  onMessageDismissed(id: number){
    //console.log(`system-message-pane\tonDismissed`, id);
    if (id === -1) {
      this.informationStore.dispatch(new fromInformationStore.DismissPreClosureBanner());
    } else {
      this.informationStore.dispatch(new fromInformationStore.DismissBanner(id));
    }
  }
}
